<template>
  <v-menu v-model="open" :close-on-content-click="false" :nudge-bottom="41">
    <template v-slot:activator="{ on }">
      <v-text-field
        outlined
        dense
        readonly
        :placeholder="placeholder"
        :label="label"
        :value="inputOutput()"
        clearable
        v-bind="$attrs"
        v-on="on"
        @click:clear="resetFilter"
      >
      </v-text-field>
    </template>

    <v-card>
      <div class="d-flex flex-column px-2 py-2">
        <v-text-field
          v-model="searchPhrase"
          dense
          outlined
          clearable
          hide-details
          label="Фильтр"
        />

        <v-row no-gutters justify="space-between" class="pa-0 pt-2">
          <v-checkbox
            v-model="isSelectedAll"
            class="outline mr-3 mt-0"
            hide-details
            label="Выбрать все"
          />
          <v-checkbox
            v-model="inverse"
            hide-details
            label="Инверсия"
            class="mt-0"
          />
        </v-row>
      </div>
      <v-divider />
      <v-card-text class="px-2 pt-0 scrollable-y" style="height: 200px;">
        <div
          v-for="(item, index) in filtredItems"
          :key="`${getItemLabel(item)}_${index}`"
          class="flex-grow-1"
        >
          <v-checkbox
            v-model="selectedItems"
            hide-details
            multiple
            :value="getItemValue(item)"
            :label="getItemLabel(item)"
          />
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-4">
        <v-spacer />
        <v-btn
          color="primary"
          depressed
          outlined
          small
          class="mr-2"
          @click="resetFilter"
        >
          Сбросить
        </v-btn>
        <v-btn color="primary" depressed small @click="applyFilter">
          Применить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { isEqual } from "lodash";
export default {
  model: {
    prop: "model",
    event: "changeFilter"
  },
  props: {
    model: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => []
    },
    textItem: {
      type: String,
      default: "text"
    },
    valueItem: {
      type: String,
      default: "value"
    },
    placeholder: {
      type: String,
      default: null
    },
    inputFormatFn: {
      type: Function,
      default: null
    },
    outputFormatFn: {
      type: Function,
      default: null
    },
    shortText: {
      type: Boolean,
      default: true
    },
    allText: {
      type: String,
      default: null
    },
    output: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selectedItems: [],
      open: false,
      inverse: false,
      searchPhrase: "",
      dirt: false
    };
  },
  computed: {
    filtredItems() {
      const { items, searchPhrase } = this;
      if (!searchPhrase || searchPhrase === "") return items;
      return items.filter(item => {
        const label = this.getItemLabel(item);
        if (!label) return false;
        return this.getItemLabel(item)
          .toUpperCase()
          .includes(searchPhrase.toUpperCase());
      });
    },
    isSelectedAll: {
      get() {
        const { items, selectedItems } = this;
        return items.length === selectedItems.length;
      },
      set(value) {
        if (value) this.selectAll();
        else this.unselectAll();
      }
    },
    inputOutput() {
      return (withLabel = false) => {
        const {
          allText,
          shortText,
          selectedItems,
          items,
          inverse,
          label,
          isSelectedAll
        } = this;
        const { inputFormatFn } = this;

        if (typeof inputFormatFn == "function")
          return inputFormatFn(
            label,
            selectedItems,
            inverse,
            items,
            isSelectedAll
          );

        if (selectedItems.length == 0) return;

        let output = withLabel && label ? `${label}: ` : "";

        output += `${inverse ? "Инверсия" : ""} `;

        if (isSelectedAll && (shortText || allText))
          output += allText ? allText : "Выбраны все";
        else {
          output += selectedItems.reduce((result, item) => {
            const sItem = this.items.find(
              i => this.getItemValue(i) === this.getItemValue(item)
            );
            result += this.getItemLabel(sItem) + ", ";
            return result;
          }, "[");
          output = output.slice(0, -2);
          output += `]`;
        }
        return output;
      };
    }
  },
  watch: {
    selectedItems: {
      handler() {
        this.dirt = true;
      },
      deep: true
    },
    items() {
      this.init();
    },
    model(newV, oldV) {
      if (!isEqual(newV, oldV)) this.onChangeModel(newV);
    },
    open(v) {
      if (!v) if (this.dirt) this.rollBack();
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const { model } = this;
      this.onChangeModel(model);
      this.$emit("init");
    },
    onChangeModel(model) {
      const { inverse, items } = model || {};
      this.selectedItems = Array.isArray(items) ? [...items] : [];
      this.inverse = typeof inverse === "boolean" ? inverse : false;
      this.applyFilter();
    },
    selectAll() {
      const { items } = this;
      let selectedItems = [];
      items.forEach(item => selectedItems.push(this.getItemValue(item)));
      this.selectedItems = selectedItems;
    },
    unselectAll() {
      this.selectedItems = [];
    },
    applyFilter() {
      const { selectedItems, inverse } = this;
      const filter =
        selectedItems.length > 0
          ? { items: [...selectedItems], inverse }
          : null;
      this.setFilter(filter);
      this.open = false;
      this.$emit("apply");
    },
    setFilter(filter) {
      this.$emit("changeFilter", filter);
      this.setOutput();
      this.dirt = false;
    },
    setOutput() {
      this.$emit("update:output", this.getOutput());
    },
    getOutput() {
      const {
        outputFormatFn,
        inputOutput,
        selectedItems,
        inverse,
        items,
        isSelectedAll
      } = this;
      const { label } = this;
      if (typeof outputFormatFn == "function")
        return outputFormatFn(
          label,
          selectedItems,
          inverse,
          items,
          isSelectedAll
        );
      else return inputOutput(true);
    },
    getItemValue(item) {
      const { valueItem } = this;
      if (typeof item == "object") return item[valueItem || "value"];
      return item;
    },
    getItemLabel(item) {
      const { textItem } = this;
      if (typeof item == "object") return item[textItem || "text"];
      return item || "...";
    },
    modelFactory() {
      return {
        inverse: false,
        items: []
      };
    },
    rollBack() {
      if (this.model) {
        const { items, inverse } = this.model;
        this.selectedItems = [...items];
        this.inverse = inverse;
        this.applyFilter();
      } else {
        this.resetFilter();
      }
      this.dirt = false;
    },
    resetFilter() {
      this.selectedItems = [];
      this.inverse = false;
      this.searchPhrase = null;
      this.applyFilter(null);
    }
  }
};
</script>
